import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from '../../store/auth/auth.reducer';
import * as fromAuth from '../../store/auth/';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as fromRouting from "../../../core/store/routing";
import { SystemNotificationsService } from '@app/core/system-notifications/system-notifications.service';

@Component({
    selector: 'topo-map-link',
    templateUrl: './map-link.component.html',
    styleUrls: ['./map-link.component.scss'],
    standalone: false
})
export class MapLinkComponent implements OnInit, OnDestroy {
  code: string;
  target: string;
  destroy$ = new Subject<void>();
  errorMessage$: Observable<string>;
  error: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<State>,
    private spinnerService: NgxSpinnerService,
    private notify: SystemNotificationsService,
    private translateService: TranslateService) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete()
  }

  ngOnInit(): void {
    this.error = false;
    this.errorMessage$ = this.store.select(fromAuth.selectMapLinkError);

    this.activatedRoute.queryParams.subscribe(params => {
      this.code = decodeURI(params['code']);
      this.target = !!params['target'] ? decodeURI(params['target']) : 'cop';
      this.store.dispatch(fromAuth.sharedMapAuthWorking({ isWorking: true }));
      this.store.dispatch(fromAuth.routeToSharedMap({ sharedCode: this.code, target: this.target }));
    });

    this.store.select(fromAuth.selectIsSharedMapWorking)
    .pipe(
      tap(isWorking => {
        isWorking ? this.spinnerService.show() : this.spinnerService.hide();
      }),
      takeUntil(this.destroy$)
    )
    .subscribe();

    this.errorMessage$
      .pipe(
        filter(err => !!err),
        tap(value => {
          this.spinnerService.hide();
          this.error = true;

          if (value == "IP_ADDRESS_IS_RESRICTED") {
            this.store.dispatch(
              fromRouting.go({
                routeData: { path: ['login/ip-restricted'] }
              })
            );
          }
          else {
            value = `ERRORS.${value}`;
            this.translateService.get(value).subscribe(res => {
              this.notify.error(res);
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
}
